module.exports = __webpack_public_path__ + "media/subscription_landing/benefit-image-10e72c96.jpg";